"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_PRIORITY_TASK = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.UPDATE_PRIORITY_TASK = (0, gql_1.gql)(`
  mutation UpdatePriorityTask($input: UpdatePriorityTaskInput!) {
    updatePriorityTask(input: $input) {
      success
      error
      instructions
      instructionsUpdatedAt
      assignedTo
      clientMutationId
      dateAssigned
      taskCount
      target
      priority
      status
      escalationReason
    }
  }
`);
